
import React from "react";

const Approach = () => {
  return (
    <div id="approach" className="method">
      <div style={{ position: "relative", marginBottom: "-20px" }} className="title-section wow animate__animated animate__fadeIn">
        Approach
      </div>
      <div className="section-022">
        <div className="section-02">
          <div className="text-section2">
            <div className="big-title3 wow animate__animated animate__fadeIn">
              Spend time on what <br /> really adds value
            </div>
            <div className="text-little">
              <div className="text-little2 wow animate__animated animate__fadeIn">
                Don't spend resources on raising money, work closely with us to identify the most strategic areas to get the optimal outcome.
                <br /> <br /> <br />
                <div className="approach-items-container">
                  <div className="approach-item">
                    <img className="icon01" src="/img/icon01.svg" alt="Finance excellence" /> 
                    <span>Finance excellence to prioritise what to do.</span>
                  </div>
                  <div className="approach-item">
                    <img className="icon01" src="/img/icon01.svg" alt="Strategic planning" /> 
                    <span>Strategic planning to analyse how to proceed.</span>
                  </div>
                  <div className="approach-item">
                    <img className="icon01" src="/img/icon01.svg" alt="Operative approach" /> 
                    <span>Operative approach to make things happen.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vidapproach">
            <div className="image-section">
              <video className="video01" autoPlay muted loop playsInline src="/img/vid01.mp4"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approach;
